import { graphql, PageProps } from 'gatsby';
import React from 'react';
import { AreaPropertyListingProps, PropertyListingContext } from '../../../types/properties';
import PropertyListing, { PropertyHead } from '../../../components/properties/PropertyListing';

const AreaPropertiesForSalePage = ({
  data: { location },
  pageContext,
}: PageProps<AreaPropertyListingProps, PropertyListingContext>) => (
  <PropertyListing properties={location.properties} location={location} pageContext={pageContext} />
);

export default AreaPropertiesForSalePage;

export const Head = ({ pageContext, data }) => <PropertyHead pageContext={pageContext} location={data?.location} />;

export const pageQuery = graphql`
  query AreaPropertiesForSalePropertyListingPageQuery($ids: [String], $locationId: String) {
    location: kfhAreaType(id: { eq: $locationId }) {
      artirixMultiSearch
      artirixDisplayName
      name
      listingMeta: propertiesForSale {
        propertyEndpointApi
        searchFacets {
          remoteTypeName
          ...SearchFacets
        }
        seo {
          ...SEO
        }
        banners {
          ...PropertyListingBanner
        }
        propertyIds {
          fallbackSearch {
            fallbackSearch
            fallbackSearchReason
          }
        }
      }
      properties(ids: $ids) {
        ...PropertyListingProperties
      }
    }
  }
`;
